



















































import BaseStep from './BaseStep.vue'
import config from '@/config/app'

export default BaseStep.extend({
  name: 'StepFour',
  data() {
    return {
      lineUrl: config.lineUrl,
    }
  },
})
